var _g, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTimelines = function SvgTimelines(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 110 110",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_461_2324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.0429688 60.7026H20.1478",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84863 75.1908H22.8105",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2207 89.6934H30.7852",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2207 31.7263H30.7852",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.84863 46.2145H22.8105",
    stroke: "#5C5D5D",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.012 102.734C91.2254 102.734 110.044 83.916 110.044 60.7026C110.044 37.4892 91.2254 18.6711 68.012 18.6711C44.7986 18.6711 25.9805 37.4892 25.9805 60.7026C25.9805 83.916 44.7986 102.734 68.012 102.734Z",
    stroke: "#7C7CF7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4293 63.0329L68.9819 63.1777C68.4464 63.1777 68.0122 62.7724 68.0122 62.2658V29.3237",
    stroke: "#7C7CF7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8052 19.3803V11.6513C59.8052 9.21972 61.7736 7.26578 64.1907 7.26578H71.8183C74.2499 7.26578 76.2039 9.2342 76.2039 11.6513V19.3803",
    stroke: "#7C7CF7",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_461_2324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTimelines, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/timelines.b4a8615c.svg";
export { ForwardRef as ReactComponent };